module.exports = __webpack_public_path__ + "img/leibie.a794bf79.svg";